import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/OAuthSession'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class OAuthSessionStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "OAuthSessionStore",
			variables: false,
		})
	}
}

export async function load_OAuthSession(params) {
  await initClient()

	const store = new OAuthSessionStore()

	await store.fetch(params)

	return {
		OAuthSession: store,
	}
}
